import type { ExistingDummyRoomDefault_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { HeaderActions } from "./components";
import { ProductExistingDummyRoomFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { DummyRoomFormMain } from "../_shared/components/root";
import { dummyRoomCategoriesAndManagerStore } from "../_shared/store/categories";

type Props = {
	serverModel: ExistingDummyRoomDefault_EditPageQuery;
};

export const DummyRoomEditPresenter = ({ serverModel }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = dummyRoomCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const roomName = init.viewModel.name.value;

	return (
		<ProductExistingDummyRoomFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader title="ダミー部屋の編集" rightChildren={<HeaderActions />} />
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={roomName} />

					<DummyRoomFormMain roomCategoriesAndManagerStore={dummyRoomCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingDummyRoomFormModelContextProvider>
	);
};

DummyRoomEditPresenter.displayName = "DummyRoomEditPresenter";
